var _rect, _path, _circle, _circle2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoimir(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#397ED3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 22.375l1.452-2.188M10.903 18l-1.451 2.188m0 0c.87.937 3.658 2.812 7.838 2.812 4.181 0 6.494-2.048 7.075-3.09M23.096 18L26 22.375",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 12.5,
    r: 1.5,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 12.5,
    r: 1.5,
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjM0IiBoZWlnaHQ9IjM0IiByeD0iNCIgZmlsbD0iIzM5N0VEMyIvPjxwYXRoIGQ9Ik04IDIyLjM3NWwxLjQ1Mi0yLjE4OE0xMC45MDMgMThsLTEuNDUxIDIuMTg4bTAgMGMuODcuOTM3IDMuNjU4IDIuODEyIDcuODM4IDIuODEyIDQuMTgxIDAgNi40OTQtMi4wNDggNy4wNzUtMy4wOU0yMy4wOTYgMThMMjYgMjIuMzc1IiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+PGNpcmNsZSBjeD0iMTMuNSIgY3k9IjEyLjUiIHI9IjEuNSIgZmlsbD0iI2ZmZiIvPjxjaXJjbGUgY3g9IjIwLjUiIGN5PSIxMi41IiByPSIxLjUiIGZpbGw9IiNmZmYiLz48L3N2Zz4=";
export { SvgMoimir as ReactComponent };